<div class="init-error-container" data-testid="init-error-container">

    <div class="server-icon">
      <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
        <!-- Server body -->
        <rect x="20" y="30" width="80" height="22" rx="4" fill="#1e3a52"/>
        <rect x="20" y="57" width="80" height="22" rx="4" fill="#1e3a52"/>
        <rect x="20" y="84" width="80" height="22" rx="4" fill="#1e3a52"/>
        <!-- Drive slots row 1 -->
        <rect x="28" y="35" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="41" y="35" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="54" y="35" width="10" height="12" rx="2" fill="#152b40"/>
        <!-- Drive slots row 2 -->
        <rect x="28" y="62" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="41" y="62" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="54" y="62" width="10" height="12" rx="2" fill="#152b40"/>
        <!-- Drive slots row 3 -->
        <rect x="28" y="89" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="41" y="89" width="10" height="12" rx="2" fill="#152b40"/>
        <rect x="54" y="89" width="10" height="12" rx="2" fill="#152b40"/>
        <!-- Status LEDs -->
        <circle cx="84" cy="41" r="3" fill="#00d4ff" class="led-blue"/>
        <circle cx="84" cy="68" r="3" fill="#ff4757" class="led-red"/>
        <circle cx="84" cy="95" r="3" fill="#334f68"/>
        <!-- Error badge -->
        <circle cx="90" cy="30" r="18" fill="#ff4757"/>
        <text x="90" y="36" text-anchor="middle" font-family="sans-serif" font-size="22" font-weight="700" fill="#fff">!</text>
      </svg>
    </div>

    <h1>Something Went Wrong</h1>
    <p>We couldn't start EVNavigation right now. This may be due to your connection or a temporary server issue.</p>
    <button class="retry-btn" data-testid="init-error-retry-btn" (click)="reload()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3 3v5h5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Try Again
    </button>

</div>